import { generatePath, useLocation } from 'react-router-dom';

import {
  ADD_FACILITY,
  ADD_FACILITY_STRING,
  COURT_CONFIG,
  COURT_CONFIG_STRING,
  DRAW,
  DRAWS,
  EDIT_FACILITY,
  EDIT_FACILITY_STRING,
  EVENT,
  EVENTS,
  FACILITIES,
  FACILITIES_STRING,
  MATCHES,
  OVERVIEW,
  PLAYERS,
  PLAYERS_PART,
  REPORTS,
  SAFE_PLAY_EXPIRED,
  SAFE_PLAY_NOT_APPROVED,
  SAFE_PLAY_NOT_STARTED,
  SAFE_PLAY_PENDING,
  SCHEDULE,
  TAB_EVENTS,
  TAB_MATCHES,
  TAB_OVERVIEW,
  TAB_PARTICIPANTS,
  TAB_REPORTS,
  TAB_SCHEDULE,
  TEAM,
  TEAMS,
  TEAMS_PART,
  TOURNAMENT_LEAGUE,
  TOURNAMENT_LEAGUES_STRING,
} from 'config/router/constants';
import { SafePlayStatus } from 'typedefs/authTypes';

export type VenueNavigationString = 'facilities' | 'court-config';

export const getTabRouteValue = (tournamentId: string, tabValue?: string) => {
  switch (tabValue) {
    case TAB_OVERVIEW:
      return generatePath(OVERVIEW, { tournamentId });
    case TAB_PARTICIPANTS:
      return generatePath(PLAYERS, { tournamentId });
    case TAB_EVENTS:
      return generatePath(EVENTS, { tournamentId });
    case TAB_MATCHES:
      return generatePath(MATCHES, { tournamentId });
    case TAB_SCHEDULE:
      return generatePath(SCHEDULE, { tournamentId });
    case TAB_REPORTS:
      return generatePath(REPORTS, { tournamentId });
    default:
      return generatePath(TOURNAMENT_LEAGUE, { tournamentId });
  }
};

export const getEventRoute = (tournamentId: string, eventId: string, drawId?: string) =>
  drawId ? generatePath(DRAW, { tournamentId, eventId, drawId }) : generatePath(EVENT, { tournamentId, eventId });

export const getDrawRoute = (tournamentId: string, eventId: string, drawId?: string) =>
  drawId ? generatePath(DRAW, { tournamentId, eventId, drawId }) : generatePath(DRAWS, { tournamentId, eventId });

export const getEventEntriesRoute = (tournamentId: string, eventId: string) =>
  generatePath(EVENT, { tournamentId, eventId });

export const getSafePlayRouteValue = (safePlayStatus?: SafePlayStatus) => {
  switch (safePlayStatus) {
    case SafePlayStatus.Pending:
      return SAFE_PLAY_PENDING;
    case SafePlayStatus.Expired:
      return SAFE_PLAY_EXPIRED;
    case SafePlayStatus.NotApproved:
      return SAFE_PLAY_NOT_APPROVED;
    default:
      return SAFE_PLAY_NOT_STARTED;
  }
};

export const getParticipantRoutes = (tournamentId: string, tabValue?: string) => {
  switch (tabValue) {
    case PLAYERS_PART:
      return generatePath(PLAYERS, { tournamentId });
    case TEAMS_PART:
      return generatePath(TEAMS, { tournamentId });
    default:
      return `/${TOURNAMENT_LEAGUES_STRING}/${tournamentId}`;
  }
};

export const getTeamRoute = (tournamentId: string, teamId: string) => generatePath(TEAM, { tournamentId, teamId });

export const useCheckSamePath = () => {
  const { pathname } = useLocation();

  return (path: string) => {
    return pathname.trim() === path.trim();
  };
};

export const getFacilityRoutes = (tournamentId: string, venueId?: string, actionRoute?: string) => {
  switch (actionRoute) {
    case FACILITIES_STRING:
      return generatePath(FACILITIES, { tournamentId });
    case ADD_FACILITY_STRING:
      return generatePath(ADD_FACILITY, { tournamentId });
    case EDIT_FACILITY_STRING:
      return generatePath(EDIT_FACILITY, { tournamentId, venueId });
    case COURT_CONFIG_STRING:
      return generatePath(COURT_CONFIG, { tournamentId, venueId });
    default:
      return;
  }
};
